import { put, call, takeLatest, select } from 'redux-saga/effects';
import { GET_DEVICE_REQUEST, getDeviceSuccess, getDeviceFailure } from '../actions/devices';
import { getDevices } from '../services/devices';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';

export const getDeviceWorker = function* ({ payload: { filters = {} } = {} } = {}) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { devices }
        } = yield call(getDevices, filters, token);

        yield put(getDeviceSuccess(devices[0] || {}));
    } catch (err) {
        yield put(getDeviceFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export default [takeLatest(GET_DEVICE_REQUEST, getDeviceWorker)];
